export const FirebaseConfig = {
	"projectId": "taxifymw",
	"appId": "1:987623205029:web:6f18fe97fe94028b11454c",
	"databaseURL": "https://taxifymw-default-rtdb.firebaseio.com",
	"storageBucket": "taxifymw.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyCADDN7Vuz2fK-lCug36xchcEeTdjuhVuE",
	"authDomain": "taxifymw.firebaseapp.com",
	"messagingSenderId": "987623205029",
	"measurementId": "G-M0BD0EHJ9X"
};